<button mat-raised-button class="image !h-full" (click)="acquireImages()">
  DTX Studio Driver
</button>
